import {CTAText, CTATitle, CTABlockContainer } from "./CTA.styles";
import { useTranslation } from 'react-i18next';

const CTA = ({children}) => {
    const { t } = useTranslation();
    return (
      <CTABlockContainer>
        <CTATitle>{t('cta.title')}</CTATitle>
        <CTAText>{t('cta.text')}</CTAText>
        <center>
            {children}
        </center>
        
      </CTABlockContainer>
    );
  };
  
  export default CTA;